(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/objects/scBlock/types/frs-donation/components/payment/partials/payment-options', '');
}]);
})();